<template>
  <div class="pc-userdetail">

    <Breadcrumb :title="'用户管理'" :data="breadcrumb" />
    <UserBasisInfo :userDetail="userDetail" />
    <div class="layout">
      <UserParse class="layout-left" :userDetail="userData" />
      <UserTag class="layout-center" :user="userDetail" />
      <!-- <UserInterest class="layout-right" :userPortrait="userPortrait" /> -->
    </div>
    <!-- <UserTrack :data="userTrack" /> -->
    <WebHistory class="WebHistory" />

    <p class="pc-userdetail-copyright">copyright©-<span>wupen.org</span></p>

  </div>
</template>



<script>
// import { getUserPortrait, getUserTrack } from './userDetail/userDetail.gql'
import {getUserDetail_Api,getUserAct_Api} from '../../../apis/user.api'

import WebHistory from './userDetail/WebHistory'
import UserTrack from './userDetail/UserTrack'
import UserInterest from './userDetail/UserInterest'
import UserTag from './userDetail/UserTag'
import UserParse from './userDetail/UserParse'
import UserBasisInfo from './userDetail/UserBasisInfo'
import Breadcrumb from '../../componentSet/BreadCrumb.vue'

export default {
  components: {
    Breadcrumb, UserBasisInfo, UserParse, UserTag, UserInterest, UserTrack, WebHistory
  },
  computed: {
    breadcrumb(){
      return [
        {name: "用户管理",link: "/admin/userlist"},
        {name: "用户列表",link: "/admin/userlist"},
        {name: "用户详情",link: "/admin/userDetail?id="+this.$route.query.id},
      ]
    }
  },
  data(){
    return {
      userPortrait: {},
      userTrack: {},
      userDetail: {},
      userData:{}
      
    }
  },
  mounted(){
    this.getUserPortrait()
    // this.getUserTrack()
  },
  methods: {
    getUserPortrait () {
      getUserDetail_Api( {user_id: this.$route.query.id}).then((res)=>{
        console.log(res.data)
        this.userDetail = res.data
        this.userData = res
      })

      // this.$global.GraphqlQuery( this, getUserPortrait, _obj ).then( res => {
      //   this.userPortrait = res.data[0];
      // })
    },
  }
}
</script>



<style lang="scss" scoped>
.pc-userdetail {
  .pc-userdetail-copyright {
    text-align: center;
    margin-top: 50px;
    font-family: $chinese;
    font-size: 14px;
    color: #434343;
    span {
      color: $timeBtn;
    }
  }
  .layout {
    overflow-y: visible;
    display: flex;
    width: 100%;
    margin-top: 40px;
    margin-bottom: 40px;
    .layout-left {
      width: 800px;
    }
    .layout-center {
      width: calc(100% - 300px);
      margin-left: 20px;
    }
  
  }
  .WebHistory {
    margin-top: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/userDetail.vue